import React from "react";
import { classNames } from "../../../../shared/utility";
import Button from "../../../ui/Button";

function getBarcodeLast9(barcode: string) {
  const text = barcode || "";
  return text.length > 9 ? text.slice(-9) : text;
}

interface ManufactureIngredientsTableProps {
  productAssemblyItems: any[];
  openAssemblyItemPopUpToAddToProduct: (item: any, isEdit: boolean) => void;
  openReceivingItemInformation: (item: any) => void;
  askDeleteProductionIngredient: (item: any) => void;
  isTraceability?: boolean;
}

export default function ManufactureIngredientsTable(
  props: ManufactureIngredientsTableProps,
) {
  const {
    productAssemblyItems,
    openAssemblyItemPopUpToAddToProduct,
    openReceivingItemInformation,
    askDeleteProductionIngredient,
    isTraceability,
  } = props;

  return (
    <div className="flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full align-middle sm:px-6 lg:px-8">
          <h3 className="text-lg mb-2">Current ingredients</h3>
          <div className="overflow-hidden card-custom">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-white">
                <tr>
                  <th
                    scope="col"
                    className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    Lot Number
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Barcode Serial
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Supplier
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Item Plu
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Item Name
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Used Unit
                  </th>
                  <th
                    scope="col"
                    className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                  ></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {productAssemblyItems.length > 0 ? (
                  productAssemblyItems.map((assemblyItem) => (
                    <tr
                      key={assemblyItem.id}
                      className={classNames(
                        assemblyItem.in_stock === 0
                          ? "bg-red-100"
                          : assemblyItem.is_used
                            ? "bg-cyan-100"
                            : null,
                      )}
                    >
                      <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {assemblyItem.lot_number}
                      </td>
                      <td className="whitespace-nowrap px-3 py-1.5 text-sm text-gray-500">
                        {assemblyItem.barcode
                          ? getBarcodeLast9(assemblyItem.barcode)
                          : "-"}
                      </td>
                      <td className="whitespace-nowrap px-3 py-1.5 text-sm text-gray-500">
                        {assemblyItem.supplier_name}
                      </td>
                      <td className="whitespace-nowrap px-3 py-1.5 text-sm text-gray-500">
                        {assemblyItem.plu}
                      </td>
                      <td className="whitespace-nowrap px-3 py-1.5 text-sm text-gray-500">
                        {assemblyItem.product_name}
                      </td>
                      <td className="whitespace-nowrap px-3 py-1.5 text-sm text-gray-500">
                        {assemblyItem.ingredient_amount_used}{" "}
                        {assemblyItem.unit_of_measure}
                      </td>
                      <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <Button
                          type="button"
                          variant="secondary"
                          size="sm"
                          onClick={() => {
                            openAssemblyItemPopUpToAddToProduct(
                              assemblyItem,
                              true,
                            );
                          }}
                          className={classNames(
                            isTraceability ? "hidden" : null,
                          )}
                        >
                          Edit
                        </Button>
                        <Button
                          type="button"
                          variant="primary"
                          size="sm"
                          onClick={() => {
                            openReceivingItemInformation(assemblyItem);
                          }}
                          className="ml-2"
                        >
                          Receiving Info
                        </Button>
                        <Button
                          type="button"
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            askDeleteProductionIngredient(assemblyItem)
                          }
                          className={classNames(
                            isTraceability ? "hidden" : null,
                            "ml-2",
                          )}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="py-5 text-center">
                      Please choose an ingredient
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
